import React, { useEffect, useState, useLayoutEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { ReportHeaderTable } from "./ReportHeaderTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectStatusParam,
  selectStepParam,
  selectReasonParam,
  fetchAll,
  fetchStatusParam,
  fetchReasonParam,
  fetchStepParam,
  selectKeepData,
  fetchExcel,
  fetchReturnId,
  selectDataReturn,
} from "./reportHeaderSlice";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { selectUser } from "../../../modules/Auth/_redux/authRedux";
import MultiSelectAll from "../../../utility/MultiSelectAll";

import { checkRoles, formatDatePost, showErrorDialog } from "../../../utility";
import DatePicker from "react-datepicker";
import {
  fetchClient,
  selectDataClient,
} from "../../new-return/with-rtv/withrtvSlice";
import {
  fetchSettingId,
  selectSettingId,
} from "../../administrator/general-setting/generalSettingSlice";

export const ReportHeaderPage = (params) => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const keepData = useSelector(selectKeepData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const statusParam = useSelector(selectStatusParam);
  const reasonParam = useSelector(selectReasonParam);
  const dataClient = useSelector(selectDataClient);
  const stepParam = useSelector(selectStepParam);
  const user = useSelector(selectUser);
  const dataSettingId = useSelector(selectSettingId);

  const defaultPlant = user.plants.map((e) => {
    return e.plantCode.toString();
  });

  const defaultClient = user.clients.map((e) => {
    return e.clientCode.toString();
  });

  // Filter
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [retNumber, setRetNumber] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [plantCode, setPlantCode] = useState([]);
  const [clientCode, setClientCode] = useState([]);
  const [reason, setReason] = useState("");
  const [status, setStatus] = useState("");
  const [step, setStep] = useState("");
  const [soStatus, setSoStatus] = useState("");
  const [typeReturn, setTypeReturn] = useState("");

  const [tableData, setTableData] = useState(data);

  const role = user.roles.map((e) => {
    return e.roleName;
  });
  const clientAllowed = ["CLIENT", "OPERATION_HO", "FPRE"];

  const clientRole = user.roles.find((role) => role.roleName === "CLIENT");

  const cutoff = dataSettingId?.plants || [];

  const { id } = useParams();

  let dateDefault =
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1) +
    "-" +
    new Date().getDate();

  // useEffect(() => {
  //   setStartDate(filterStartDate);
  //   setEndDate(filterStartDate);
  // }, []);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);

    if (data.length > 0) {
      // const check = detail.length === approvalStatus.length ? true : false;
      const initData = data.map((item, index) => {
        var totalDetail = data[index].items;

        var approvalStatus = totalDetail.filter(function(totalDetail) {
          return totalDetail.approvalStatus === "R";
        });

        const check =
          totalDetail.length === approvalStatus.length ? true : false;

        return {
          ...item,
          no: index + 1 + pageBefore,
          statusReject: check,
        };
      });
      setTableData(initData);
    }
  }, [data, pageSize, pageNo]);

  useEffect(() => {
    async function fetchMyAPI() {
      // Reset on first load
      dispatch(resetData());

      await dispatch(
        fetchStatusParam({
          paramGroupId: "STATUS",
          pageNo: 1,
          pageSize: 20,
        })
      );

      await dispatch(
        fetchReasonParam({
          paramGroupId: "REASON",
          pageNo: 1,
          pageSize: 20,
        })
      );

      await dispatch(
        fetchStepParam({
          paramGroupId: "STEP_APPROVAL",
          pageNo: 1,
          pageSize: 20,
        })
      );
      await dispatch(
        fetchClient({
          pageNo: 1,
          pageSize: 1000,
        })
      );
      await dispatch(fetchSettingId("cut.off.fareye"));
    }

    const plants = user.plants.map((e) => {
      return e.plantCode.toString();
    });

    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      if (id != null) {
        await dispatch(
          fetchAll({
            retNumber: id,
            pageNo: pageNo,
            pageSize: pageSize,
          })
        );
      }
    }

    fetchMyAPI();
  }, [id]);

  useEffect(() => {
    setPlantCode(defaultPlant);
    setClientCode(defaultClient);
  }, []);

  const reasonOptions = [
    { value: "", label: "All" },
    ...reasonParam.map((e) => {
      const item = {};
      item.value = e.paramCode;
      item.label = e.paramValue;
      return item;
    }),
  ];

  const getValueReason = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const getValueStatus = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const statusOptions = [
    { value: "", label: "All" },
    ...statusParam.map((e) => {
      const item = {};
      item.value = e.paramCode;
      item.label = e.paramValue;
      return item;
    }),
  ];
  const stepOptions = [
    { value: "", label: "All" },
    ...stepParam.map((e) => {
      const item = {};
      item.value = e.paramCode;
      item.label = e.paramValue;
      return item;
    }),
  ];

  const handlePlantsChange = (selectedOptions) => {
    if (selectedOptions) {
      setPlantCode(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setPlantCode([]);
    }
  };

  const plantOptions = user.plants.map((val) => {
    return {
      value: val.plantCode,
      label: val.plantName,
    };
  });

  function getValuePlant(plant) {
    let output = [];
    plant.map((val) => {
      const result = plantOptions.filter((plant) => val == plant.value);
      output.push(result[0]);
    });
    return output;
  }

  // client code
  const handleClientChange = (selectedOptions) => {
    if (selectedOptions) {
      setClientCode(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setClientCode([]);
    }
  };

  const clientOptions =
    user.clients.length > 0
      ? user.clients.map((val) => {
          return {
            value: val.clientCode,
            label: val.clientName,
          };
        })
      : dataClient.map((val) => {
          return {
            value: val.clientCode,
            label: val.clientName,
          };
        });

  function getValueClient(client) {
    let output = [];
    client.map((val) => {
      const result = clientOptions.filter((client) => val == client.value);
      output.push(result[0]);
    });
    return output;
  }

  const getValueStep = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleSearch = () => {
    // const filterEndDate = endDate === filterStartDate ? "" : endDate;
    if (plantCode.length < 1) {
      return showErrorDialog("Please select plant");
    }

    if (defaultClient.length > 1 && clientCode < 1) {
      return showErrorDialog("Please select Client ");
    }

    const params = {
      startDate: formatDatePost(startDate),
      endDate: formatDatePost(endDate),
      retNumber: retNumber.replace(/\s/g, ""),
      invoiceNo: invoiceNo,
      customerName: customerName,
      customerCode: customerCode,
      reasonCode: reason,
      clientCode: clientCode.toString(),
      stepCode: step,
      plantCode: plantCode.toString(),
      status: status,
      soStatus: soStatus,
      typeReturn: typeReturn,
      pageNo: 1,
      pageSize: 10,
    };
    console.log(params, "params");
    dispatch(fetchAll(params));
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      if (plantCode.length < 1) {
        return showErrorDialog("Please select plant");
      }

      if (defaultClient.length > 1 && clientCode < 1) {
        return showErrorDialog("Please select Client ");
      }
      const params = {
        startDate: formatDatePost(startDate),
        endDate: formatDatePost(endDate),
        retNumber: retNumber.replace(/\s/g, ""),
        invoiceNo: invoiceNo,
        customerName: customerName,
        customerCode: customerCode,
        reasonCode: reason,
        clientCode: clientCode.toString(),
        status: status,
        stepCode: step,
        plantCode: plantCode.toString(),
        soStatus: soStatus,
        typeReturn: typeReturn,
        pageNo: page,
        pageSize: sizePerPage,
      };
      dispatch(fetchAll(params));
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
        console.log(result, "asc");
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleExcel = () => {
    // Validation
    if (startDate === "" || startDate === null) {
      return showErrorDialog("Please Input Registration Date!");
    }

    if (endDate === "" || endDate === null) {
      return showErrorDialog("Please Input Registration Date!");
    }

    if (plantCode.length < 1) {
      return showErrorDialog("Please select plant");
    }

    const extendedData = clientCode.flatMap((item) => [item, "0000" + item]);

    let URL_EXCEL =
      `${process.env.REACT_APP_API_URL}/return/xlsx` +
      `?startDate=${formatDatePost(startDate)}` +
      `&endDate=${formatDatePost(endDate)}` +
      `&retNumber=${retNumber}` +
      `&invoiceNo=${invoiceNo}` +
      `&customerCode=${customerCode}` +
      `&customerName=${customerName}` +
      `&clientCode=${extendedData.toString()}` +
      `&plantCode=${plantCode.toString()}` +
      `&reasonCode=${reason}` +
      `&status=${status}` +
      `&typeReturn=${typeReturn}`;

    window.open(URL_EXCEL);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const soOptions = [
    { value: "", label: "All" },
    { value: "SUCCESS", label: "Success" },
    { value: "FAILED", label: "Failed" },
  ];

  const typeReturnOptions = [
    { value: "", label: "All" },
    { value: "MTKA", label: "With RTV" },
    { value: "NON MTKA", label: "Without RTV" },
  ];

  const getValueSoStatus = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };
  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Report Header">
        <CardHeaderToolbar>
          <Button variant="primary" onClick={handleExcel}>
            Download Excel
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* Filter */}
        <Form as={Row}>
          {/* Left Row */}
          <Col sm={7}>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Registration Date</b>
              </Form.Label>
              <Col sm={4}>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  isClearable
                  placeholderText="dd/mm/yyyy"
                />
              </Col>
              <p className="mt-3">To</p>
              <Col sm={4} onKeyPress={handleKeyPress}>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  isClearable
                  placeholderText="dd/mm/yyyy"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="retNumber">
              <Form.Label column sm={3}>
                <b>APL Return Number </b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  placeholder="APL Return Number "
                  onChange={(e) => {
                    setRetNumber(e.target.value);
                  }}
                  value={retNumber}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Invoice Ref Number</b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="number"
                  placeholder="Invoice Ref Number"
                  onChange={(e) => {
                    setInvoiceNo(e.target.value);
                  }}
                  value={invoiceNo}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Plants</b>
              </Form.Label>
              <Col sm={4}>
                <MultiSelectAll
                  options={plantOptions}
                  value={getValuePlant(plantCode)}
                  onChange={handlePlantsChange}
                  placeholder="Select Plant..."
                />
              </Col>
            </Form.Group>

            {checkRoles(role, clientAllowed) && (
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Clients</b>
                </Form.Label>
                <Col sm={4}>
                  <MultiSelectAll
                    options={clientOptions}
                    value={getValueClient(clientCode)}
                    onChange={handleClientChange}
                    placeholder="Select Client"
                  />
                </Col>
              </Form.Group>
            )}
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Reason</b>
              </Form.Label>
              <Col sm={4}>
                <Select
                  options={reasonOptions}
                  value={getValueReason(reason, reasonOptions)}
                  placeholder="Select Reason..."
                  onChange={(e) => {
                    setReason(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
          </Col>

          {/* Right Row */}
          <Col sm={5}>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Customer Code</b>
              </Form.Label>
              <Col sm={6}>
                <Form.Control
                  type="text"
                  placeholder="Customer Code"
                  onChange={(e) => {
                    setCustomerCode(e.target.value);
                  }}
                  value={customerCode}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Customer Name</b>
              </Form.Label>
              <Col sm={6}>
                <Form.Control
                  type="text"
                  placeholder="Customer Name"
                  onChange={(e) => {
                    setCustomerName(e.target.value);
                  }}
                  value={customerName}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b> Status</b>
              </Form.Label>
              <Col sm={6}>
                <Select
                  options={statusOptions}
                  value={getValueStatus(status, statusOptions)}
                  placeholder="Select Status..."
                  onChange={(e) => {
                    setStatus(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Pending Prosess</b>
              </Form.Label>
              <Col sm={6}>
                <Select
                  options={stepOptions}
                  value={getValueStep(step, stepOptions)}
                  placeholder="Select Status..."
                  onChange={(e) => {
                    setStep(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Status SO</b>
              </Form.Label>
              <Col sm={6}>
                <Select
                  options={soOptions}
                  value={getValueSoStatus(soStatus, soOptions)}
                  placeholder="Select Status..."
                  onChange={(e) => {
                    setSoStatus(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Type Return</b>
              </Form.Label>
              <Col sm={6}>
                <Select
                  options={typeReturnOptions}
                  value={getValueSoStatus(typeReturn, typeReturnOptions)}
                  // placeholder="Select ..."
                  onChange={(e) => {
                    setTypeReturn(e.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Col>
            </Form.Group>
          </Col>

          {/* Button */}
          <Form.Group as={Row} className="ml-1">
            <Col sm={6}>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <div className="table-container">
            <ReportHeaderTable
              data={tableData}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
              cutoff={cutoff}
            />
          </div>
        )}
      </CardBody>
    </Card>
  );
};
